import Navbar from "../../../NavBar/Navbar"
import SideBar from "../../../NavBar/Sidebar"
import ImprimirContent from "./ImprimirContent"

interface ChildsProps {
    logout: () => void
}

const Imprimir: React.FC<ChildsProps> = ({logout}) => {

   
        
    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            <ImprimirContent/>
        </div>

    </div>
    )
}


export default Imprimir